const BULK_EXPORT_ROLES = new Set(['OWNER', 'ADMIN', 'REFERRAL_COORDINATOR']);

/** Same database-role mapping used by getUserRoleProfile. */
export function canonicalApplicationRole(role: unknown): string {
  const raw = String(role ?? '').trim().toUpperCase();
  if (raw === 'ADMIN') return 'ADMIN';
  if (raw === 'OWNER') return 'OWNER';
  if (raw === 'REFERRAL_COORDINATOR' || raw === 'OFFICE') return 'REFERRAL_COORDINATOR';
  if (raw === 'SUPERVISOR' || raw === 'CLINICIAN') return 'SUPERVISOR';
  if (raw === 'ASSISTANT') return 'ASSISTANT';
  return 'ASSISTANT';
}

export function canBulkExportRecords(user: { role?: unknown; activeRole?: unknown } | null | undefined): boolean {
  const active = String(user?.activeRole ?? '').trim() || String(user?.role ?? '').trim();
  return BULK_EXPORT_ROLES.has(canonicalApplicationRole(active));
}

export function recordsExportCompletionNote(included: number, notExported: number, exportedWithIssues: number): string {
  if (notExported === 0 && exportedWithIssues === 0) {
    return `Export ready: ${included} files. See inventory for details.`;
  }
  return `Export ready: ${included} files. Not exported: ${notExported}. Exported with issues: ${exportedWithIssues}. See inventory for details.`;
}
